import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anonKey) {
  // Surfaced in the console + UI banner rather than crashing the shell, so the
  // PWA still installs/loads offline even before Supabase is configured.
  // eslint-disable-next-line no-console
  console.warn(
    '[supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are not set. ' +
      'Copy .env.example to .env.local and fill them in.',
  );
}

export const isSupabaseConfigured = Boolean(url && anonKey);

/**
 * Single shared client. Magic-link auth (no passwords). Session is persisted so
 * a canvasser stays signed in across launches and offline reloads.
 */
export const supabase = createClient(url ?? 'http://localhost:54321', anonKey ?? 'public-anon-key', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});
